import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Button, Link, Stack, TextField, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllActiveClientDetails } from "src/clients/ClientService";
import { clientDetailsUpdate } from "src/redux/slices/clientDetailsSlice";
import { getByUsernameAndPassword } from "../../clients/UserService";
import { login } from "../../redux/slices/userSlice";
import NotifyError from "../notifications/NotifyError";
import loginstyles from "./Login.module.css";

export const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [userNameError, setUserNameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  // const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleUserNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(event.target.value);
    setUserNameError(false);
    setPasswordError(false);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
    setPasswordError(false);
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    getByUsernameAndPassword(username, password)
      .then(async (res) => {
        if (res.ok) {
          const userDetails = await res.json();
          if (userDetails.username !== null) {
            dispatch(
              login({
                userDetailsId: userDetails.userDetailsId,
                userId: username,
                password: password,
                email: userDetails.email,
                role: userDetails.role.roleName,
                permissionsList: userDetails.permissionsList,
                productCode: userDetails.defaultProduct,
                firstName: userDetails.firstName,
                lastName: userDetails.lastName,
                products: userDetails.products,
                filesStatus: true,
                clientId: userDetails.clientId,
                clientCode: userDetails.clientCode,
                selectedClient: null,
                auth: `Basic ${btoa(`${username}:${password}`)}`,
              })
            );
            if (
              userDetails.role.roleName === "SYSTEM_ADMIN" ||
              userDetails.role.roleName === "SYSTEM_USER"
            ) {
              const clientListRes = await getAllActiveClientDetails(
                username,
                password
              );
              if (clientListRes.ok) {
                const clientList = await clientListRes.json();
                dispatch(clientDetailsUpdate(clientList));
              }
            }
            navigate("/");
          } else {
            setPasswordError(false);
            toast.error(
              <NotifyError header={"Error"}>
                <Typography variant="body2">
                  Attempting to log in with an inactive user account
                </Typography>
              </NotifyError>,
              {
                icon: false,
                closeButton: false,
              }
            );
          }
        } else if (res.status === 401) {
          setPasswordError(true);
          toast.error(
            <NotifyError header={"Error"}>
              <Typography variant="body2">
                Invalid username or password
              </Typography>
            </NotifyError>,
            {
              icon: false,
              closeButton: false,
            }
          );
        }
      })
      .catch(() => {
        setPasswordError(true);
        toast.error(
          <NotifyError header={"Error"}>
            <Typography variant="body2">
              Invalid username or password
            </Typography>
          </NotifyError>,
          {
            icon: false,
            closeButton: false,
          }
        );
      });
  };

  return (
    <>
      <Container className={loginstyles.logincontainer}>
        <Container className={loginstyles.loginformcontainer}>
          <form onSubmit={handleSubmit}>
            <Stack
              direction="column"
              alignItems="center"
              spacing={2}
            >
              <Typography variant="h5">Sign In</Typography>
              <Container className={loginstyles.passworderrorcontainer}>
                {passwordError && (
                  <Typography className={loginstyles.passwordmessage}>
                    The username or password isnt right
                  </Typography>
                )}
              </Container>
              <TextField
                type="text"
                value={username}
                fullWidth
                id="filled-basic"
                size="small"
                label="Username"
                variant="outlined"
                onChange={handleUserNameChange}
                required
                error={userNameError}
                helperText={
                  userNameError ? (
                    <span className={loginstyles.errormessage}>
                      Username not found
                    </span>
                  ) : (
                    ""
                  )
                }
              />

              <TextField
                id="password-input"
                label="Password"
                type={showPassword ? "text" : "password"}
                fullWidth
                size="small"
                value={password}
                onChange={handlePasswordChange}
                autoComplete="current-password"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleTogglePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                required
                error={passwordError}
              />
            </Stack>
            <Stack
              direction="column"
              sx={{ mt: 2 }}
              alignItems="center"
              my={1}
            >
              <Link
                href="forgotPassword"
                className={loginstyles.loginlink}
              >
                Forgot password
              </Link>
              <Button
                variant="outlined"
                type="submit"
              >
                Sign In
              </Button>
            </Stack>
            <Stack
              direction="column"
              sx={{ mt: 2 }}
              alignItems="center"
            >
              <Typography>
                Copyright © {new Date().getFullYear()} {"Red-Shift"}.
              </Typography>
              <Typography>All rights reserved.</Typography>
            </Stack>
          </form>
        </Container>
      </Container>
    </>
  );
};
